document.addEventListener('DOMContentLoaded', () => {
    const bynderVideoElements = document.querySelectorAll('.bynder-video')

    for (const videoElement of bynderVideoElements) {
        let autoplay = videoElement.hasAttribute('autoplay')
        let parent = videoElement.parentNode
        let playing = false

        videoElement.addEventListener('click', () => {
            parent.classList.add('hide-play')

            if (!autoplay && !playing) {
                videoElement.play()
                playing = !playing
            }

            if (parent.classList.contains('has-play')) videoElement.setAttribute('controls', true)
        })

        if (autoplay) videoElement.play()
    }
})
